// extracted by mini-css-extract-plugin
module.exports = {"container":"DownloadApps_container__1ApxB","apps":"DownloadApps_apps__3OWb0","title":"DownloadApps_title__257UO","img":"DownloadApps_img__3S2op"};